import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import * as accountService from '../../../services/account'

import { updateAccount } from '../../../actions/account';

import PaymentSuccessVector from '../../../assets/vector/paymentSuccess.svg';

import './styles.css';

const PaymentSuccess = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const accountId = searchParams.get('accountId'); 

    const handleGetAccount = async () => {
        const response = await accountService.getAccount(accountId);

        if (response) {
            dispatch(updateAccount(response));
            navigate('/')
        } else {
            navigate('/auth')
        }
    }

    setTimeout(() => handleGetAccount(), 1500);

    return (
        <div className="payment-success-container">
            <div className='payment-success-content'>
                <img src={PaymentSuccessVector} alt=""/>
                <h2>Payment Successful!</h2>
                <p>Your payment has been processed successfully. Thank you for your support!</p>
                <p>Redirecting you to your account...</p>
            </div>
        </div>
    );
};

export default PaymentSuccess;
